<template>
  <div class="practice-detail container">
    <div class="box">
      <el-page-header @back="$router.go(-1)" content="实战编辑">
      </el-page-header>
      <el-form
        :model="params"
        class="form"
        size="small"
        label-width="90px"
        label-position="left"
      >
        <el-form-item prop="taskType" label="实战类型：">
          <el-select
            v-model="params.taskType"
            filterable
            placeholder="请选择实战类型"
            :disabled="!!$route.query.taskId"
          >
            <el-option label="个人" value="PERSONAL"> </el-option>
            <el-option label="团队" value="TEAM"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="title" label="实战名称：">
          <el-input
            v-model="params.title"
            placeholder="请输入实战名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <p style="margin-bottom: 20px">实战内容：</p>
      <editor
        :outContent="params.content"
        @content="updateContent"
        placeholder="请输入实战内容"
      />
      <div class="btns">
        <el-button class="btn" type="primary" size="small" @click="onSubmit(1)"
          >保存</el-button
        >
        <el-button
          class="btn"
          type="primary"
          size="small"
          v-if="$route.query.isBank"
          @click="onSubmit(2)"
          >保存并发布</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  bankAddPractice,
  bankPracticeInfo,
  practiceInfo,
  editPractice,
  bankEditPractice,
  bankReleasePractice,
} from "@/api/practice";
import editor from "@/components/editor";
export default {
  components: {
    editor,
  },
  data() {
    return {
      params: {
        classId: null,
        chapterId: null,
        classChapterId: null,
        taskType: "PERSONAL",
        title: "",
        content: "",
      },
    };
  },
  activated() {
    let taskId = this.$route.query.taskId;
    let isBank = this.$route.query.isBank;
    if (taskId) {
      this.$loading.show();
      (isBank ? bankPracticeInfo : practiceInfo)(taskId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.params = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  },
  deactivated() {
    this.params = this.$options.data().params;
  },
  methods: {
    updateContent(val) {
      this.params.content = val;
    },
    onSubmit(type) {
      if (!this.params.title.trim()) {
        this.$message.warning("实战名称不能为空");
        return;
      } else if (!this.params.content.trim()) {
        this.$message.warning("实战内容不能为空");
        return;
      }
      this.params.classId = this.$route.query.id;
      this.params.chapterId = this.$route.query.chapterId;
      this.params.classChapterId = this.$route.query.classChapterId;

      if (this.$route.query.isBank) {
        // 实战库
        if (this.$route.query.taskId) {
          // 编辑
          this.$loading.show();
          bankEditPractice(this.params).then((res) => {
            if (type == 1) this.$loading.hide();
            if (res.code == 0) {
              if (type == 1) {
                this.$message.success("修改成功");
                this.$router.go(-1);
              } else {
                let taskStoreId = this.$route.query.taskId;
                let classId = this.$route.query.id;
                let chapterId = this.$route.query.chapterId;
                this.handleRelease(taskStoreId, classId, chapterId);
              }
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          // 新增
          this.$loading.show();
          bankAddPractice(this.params).then((res) => {
            if (type == 1) this.$loading.hide();
            if (res.code == 0) {
              if (type == 1) {
                this.$message.success("保存成功");
                this.$router.go(-1);
              } else {
                let taskStoreId = res.data.taskStoreId;
                let classId = this.$route.query.id;
                let chapterId = this.$route.query.chapterId;
                this.handleRelease(taskStoreId, classId, chapterId);
              }
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      } else {
        // 已发布的实战
        this.$loading.show();
        editPractice(this.params).then((res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.$message.success("修改成功");
            this.$router.go(-1);
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    handleRelease(taskStoreId, classId, chapterId) {
      bankReleasePractice({ taskStoreId, classId, chapterId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("发布成功");
          this.$router.go(-2);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.practice-detail {
  height: 100%;
  text-align: left;
  .box {
    position: relative;
    padding: 25px 35px;
    margin: 30px auto;
    height: calc(100% - 60px);
    background-color: #fff;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    ::v-deep .el-page-header {
      margin-bottom: 20px;
      .el-page-header__content {
        font-size: 16px;
      }
    }
    .btns {
      position: absolute;
      top: 25px;
      right: 35px;
    }
  }
}
</style>